import { Link } from "react-router-dom";
import styled from "styled-components";
import Button from "../../components/Button";

const Box = ({ imageSrc }) => {
  return (
    <div className="max-w-[400px]  mx-auto flex items-center pt-12">
      <Link to={"../shop/product"}>
        <HoveredBox className="group flex flex-col items-center  transition-all duration-300">
          <div className="image">
            <div>
              <img src={imageSrc} alt="" />
            </div>
          </div>
          <div className="package-info flex flex-col text-sm items-center transition-all duration-500 bg-white group-hover:shadow-lg mx-6 p-4 pt-6">
            <div className="price-period flex flex-col text-[#e66553]">
              <div className="old-price line-through text-black mb-2">
                <span>₺999 yerine</span>
              </div>
              <div className="current-price font-medium  text-[35px] py-2">
                <h4>₺299</h4>
              </div>
              <div className="period font-normal">
                <span>1 aylık üyelik</span>
              </div>
            </div>
            <div className="specs p-6 text-[#828282]">
              <ul className="text-center">
                <li className="pt-2">ücretsiz kargo</li>
                <li className="pt-2">kapınıza teslim</li>
                <li className="pt-2">50₺ Hediye Çeki</li>
                <li className="pt-2">teslim kapınıza</li>
              </ul>
            </div>
            <div className="actions flex flex-wrap justify-center items-center">
              <div className="m-2 flex-auto">
                <Button width={"w-full"}>ABONE OL</Button>
              </div>
              <div className="m-2 flex-auto">
                <Button
                  isHovered
                  font={"text-[15px] text-black"}
                  hover={"hover:text-[#e66553]"}
                  backgroundColor={"bg-white"}
                  border={"border-2 border-[#e66553]"}
                  width="w-full"
                >
                  sevdiklerinize
                </Button>
              </div>
            </div>
          </div>
        </HoveredBox>
      </Link>
    </div>
  );
};

const HoveredBox = styled.div`
  &:hover {
    transform: translateY(-18px);
  }

  &:hover .package-info {
    transform: translateY(-8px);
  }
`;

export default Box;
